__webpack_public_path__ = altosoft.rootPath + 'build/';
/* tslint:disable:ordered-imports */
import 'core-js/es';
import '@Common/Core/Extension';
